import { render } from "./RequirementsList.vue?vue&type=template&id=729d9416&scoped=true"
import script from "./RequirementsList.vue?vue&type=script&lang=js"
export * from "./RequirementsList.vue?vue&type=script&lang=js"

import "./RequirementsList.vue?vue&type=style&index=0&id=729d9416&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729d9416"]])

export default __exports__